export const removeDuplicates = (arr: any, key: string) => {
  const seen = new Set();
  return arr.filter((obj: any) => {
    const keyValue = key ? obj[key] : JSON.stringify(obj);
    const isDuplicate = seen.has(keyValue);
    seen.add(keyValue);
    return !isDuplicate;
  });
};
